import { render, staticRenderFns } from "./Expensive.vue?vue&type=template&id=06f7e89e&"
import script from "./Expensive.vue?vue&type=script&lang=js&"
export * from "./Expensive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports